import { useQueryClient } from '@tanstack/react-query';
import { BroadcastTopics } from 'services/wsService';

import { getPatientInfoKey } from './use-patient-info';
import { useWebsocketRoom } from '../websockets/use-room';
import { useSocketOn } from '../websockets/use-socket-on';

import type { RpmStatuses } from 'infrastructure/enums';
import type { IPatient } from 'infrastructure/interfaces';

interface ISocketData {
  status: RpmStatuses;
}

interface Props {
  patientGuid: string;
}

export const useRealTimeUpdatePatientStatus = ({ patientGuid }: Props) => {
  const queryClient = useQueryClient();

  useWebsocketRoom('rpmPatientProfile', { patientGuid });
  useSocketOn(BroadcastTopics.PatientStatusChange, (data: ISocketData) => {
    updateQueryPatientStatus(data);
  });

  const updateQueryPatientStatus = (socketData: ISocketData) => {
    const queryKey = getPatientInfoKey(patientGuid);

    queryClient.setQueryData<IPatient>(
      queryKey,
      (oldData) =>
        oldData && {
          ...oldData,
          status: socketData.status,
        },
    );
  };
};
